module.exports = __webpack_public_path__ + "img/1f607.2330cf6.svg";